import React,{useContext} from "react";
import money_rounding from '../../../utils/money_rounding';
import numberbeautify from '../../../utils/numberbeautify';
import show_million_format from '../../../utils/show_million_format';
import iqd_rounding from "../../../utils/iqd_rounding";
import moment from "moment/moment";
import { GlobalContext } from "../../../context/provider";

export const Mizania_table_print = React.forwardRef((props, ref) => {
    const { initState } = useContext(GlobalContext);
    return (
        <div ref={ref}>
            <div className="mt-20 mx-3 p-2 flex justify-center" style={{border:'2px solid black'}}>
                شركة خندةي مال للتجارة العامة و المستلزمات المنزلية / المحدودة
            </div>
            <div className="flex justify-center underline">
                الميزانية العامة كما في {props?.mizania_date}/12/31
            </div>
            <div className="my-2 mx-3">
                <table className="w-full border-collapse border border-slate-800" dir="rtl">
                    <thead>
                        <tr>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>رقم</div>
                                <div>الكشف</div>
                            </th>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>رقم</div>
                                <div>الدليل</div>
                            </th>
                            <th className="border border-slate-800 px-0 py-2">اسم الحساب</th>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>السنة الحالية</div>
                                <div>دينار/الف</div>
                            </th>
                            <th className="border border-slate-800 px-0 py-2">
                                <div>السنة السابقة</div>
                                <div>دينار/الف</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                1
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                الموجودات
                            </td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                        </tr>
                        {props?.assets?.map((item, index)=>(
                            <tr key={index}>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(money_rounding(item?.current_amount))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(money_rounding(item?.previous_amount))}
                                </td>
                            </tr>
                        ))}
                        {props?.assets?.length>0&&(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1">
                                    المجموع
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(props?.assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(props?.assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                الموجودات الثابتة
                            </td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                        </tr>
                        {props?.fixed_assets?.map((item, index)=>(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(item?.current_amount)))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(item?.previous_amount)))}
                                </td>
                            </tr>
                        ))}
                        {props?.fixed_assets?.length>0&&(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1">
                                    المجموع
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(props?.fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0) || 0))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(props?.fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0) || 0))))}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                الموجودات المتداولة
                            </td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                137
                            </td>
                            <td className="border border-slate-800 px-1 py-1">
                                المخزون
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(money_rounding(props?.total_warehouse_price)))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(money_rounding(props?.total_previous_warehouse_price)))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                15
                            </td>
                            <td className="border border-slate-800 px-1 py-1">
                                 المدينون
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(money_rounding(props?.total_loan_sold)))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                {numberbeautify(show_million_format(money_rounding(props?.total_previous_loan_sold)))}
                            </td>
                        </tr>
                        {props?.current_assets?.map((item, index)=>(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(item?.current_amount || 0))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(item?.previous_amount || 0))))}
                                </td>
                            </tr>
                        ))}
                        {(props?.current_assets?.length>0||props?.total_loan_sold>0||props?.total_previous_loan_sold>0||props?.total_previous_warehouse_price>0||props?.total_warehouse_price>0)&&(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1">
                                    المجموع
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(Number(props?.current_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(props?.total_loan_sold)+Number(props?.total_warehouse_price))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(Number(props?.current_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(props?.total_previous_loan_sold)+Number(props?.total_previous_warehouse_price))))}
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1">
                                 مجموع الموجودات
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline text-center">
                                {numberbeautify(show_million_format(money_rounding(Number(props?.assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(props?.fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(props?.current_assets?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(props?.total_loan_sold)+Number(props?.total_warehouse_price))))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline text-center">
                                {numberbeautify(show_million_format(money_rounding(Number(props?.assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(props?.fixed_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(props?.current_assets?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(props?.total_previous_loan_sold)+Number(props?.total_previous_warehouse_price))))}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                2
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                مصادر التمويل
                            </td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                        </tr>
                        {props?.funding_sources?.map((item, index)=>(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(item?.current_amount || 0))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(item?.previous_amount || 0))))}
                                </td>
                            </tr>
                        ))}
                        {props?.funding_sources?.length>0&&(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1">
                                    المجموع 
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(props?.funding_sources?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(props?.funding_sources?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))))}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1 underline">
                                 المطلوبات المتداولة
                            </td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                            <td className="border border-slate-800 px-1 py-1"></td>
                        </tr>
                        <tr>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                4
                            </td>
                            <td className="border border-slate-800 px-1 py-1 text-center">
                                26
                            </td>
                            <td className="border border-slate-800 px-1 py-1">
                                 الدائنون
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline text-center">
                                {numberbeautify(show_million_format(money_rounding(Number(props?.total_loan_bought))))}
                            </td>
                            <td className="border border-slate-800 px-1 py-1 underline text-center">
                                {numberbeautify(show_million_format(money_rounding(Number(props?.total_previous_loan_bought))))}
                            </td>
                        </tr>
                        {props?.current_liabilities?.map((item, index)=>(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_statement_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {item?.mizania_directory_number}
                                </td>
                                <td className="border border-slate-800 px-1 py-1">
                                    {item?.mizania_name}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(item?.current_amount || 0))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(parseFloat(item?.previous_amount || 0))))}
                                </td>
                            </tr>
                        ))}
                        {(props?.current_liabilities?.length>0||(Number(props?.total_loan_bought)>0)||(Number(props?.total_previous_loan_bought)>0))&&(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1">
                                    المجموع
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(Number(props?.current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(props?.total_loan_bought))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(Number(props?.current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(props?.total_previous_loan_bought))))}
                                </td>
                            </tr>
                        )}
                        {(props?.current_liabilities?.length>0||props?.funding_sources?.length>0||(Number(props?.total_loan_bought)>0)||(Number(props?.total_previous_loan_bought)>0))&&(
                            <tr>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1"></td>
                                <td className="border border-slate-800 px-1 py-1">
                                    مجموع مصادر التمويل
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(Number(props?.funding_sources?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0)) + Number(props?.current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.current_amount || 0), 0))+Number(props?.total_loan_bought))))}
                                </td>
                                <td className="border border-slate-800 px-1 py-1 text-center">
                                    {numberbeautify(show_million_format(money_rounding(Number(props?.funding_sources?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0)) + Number(props?.current_liabilities?.reduce((acc, item) => acc + parseFloat(item?.previous_amount || 0), 0))+Number(props?.total_previous_loan_bought))))}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
});
